/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { Container } from '../../../styles/Grid';
import { Picture } from '../../ui/Picture';
import * as Styles from './index.style';
import Spacer from '../../ui/Spacer';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import TitleBlock from './TitleBlock';
import ScrollerBlock from './ScrollerBlock';
import { get, throttle } from 'lodash';

import { Breakpoints } from '../../../styles/Grid/GridSizes';
import scrollBlocker from '../../../utils/scrollBlocker.js';

import {
  isDesktop,
  isMobileOnly,
  isTablet,
  isFirefox,
} from 'react-device-detect';
// console.log('** isDesktop', isDesktop);
// console.log('** isMobileOnly', isMobileOnly);
// console.log('** isTablet', isTablet);
// console.log('** isFirefox', isFirefox);

import { CLOUDINARY_BASE_VALUES } from '../../../utils/constants';

const mainImageSizes = {
  [Breakpoints.sm]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 375,
    height: 592,
    gravity: 'auto:subject',
  },
  [Breakpoints.md]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 768,
    height: 544,
    gravity: 'auto:subject',
  },
  [Breakpoints.lg]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 1024,
    height: 680,
    gravity: 'auto:subject',
  },
  [Breakpoints.xl]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 1312,
    height: 813,
    gravity: 'auto:subject',
  },
};

const scrollBreakPoint = 1024;
const scrollIpadBreakPoint = 768;

const GetMarginValue = scrollElementHeighht => {
  let componentEl = document.querySelector('.feature-hero');
  let componentElStyle = window.getComputedStyle(componentEl);
  let componentElHeight = parseInt(componentElStyle.height, 10);

  let marginVal = (componentElHeight - scrollElementHeighht) / 2;

  return marginVal + marginVal / 2;
};
class FeatureHeros extends SafePureComponent {
  state = {
    wHeight: 0,
    wWidth: 0,
    scrollShadow: {},
    scrollMeVisibility: 'hidden',
  };
  FeatureHerosRef = React.createRef();

  constructor(props) {
    super(props);
    this.handleScrollThrottled = throttle(this.onScroll, 100);
    this.handleMousewheelThrottled = throttle(this.onMousewheel, 100);
  }

  componentDidMount() {
    this.sticker = document.querySelector('#scrollMe');

    this.updateSize();
    window.addEventListener('resize', this.updateSize);
  }
  componentWillUnmount() {
    this.removeScrollListener();

    window.removeEventListener('resize', this.updateSize);
  }

  bindScrollListener = () => {
    // window.addEventListener('DOMMouseScroll', this.onScroll);
    window.addEventListener('scroll', this.handleScrollThrottled);
    // window.addEventListener('scroll', this.onScroll);
    // window.addEventListener('touchmove', this.moveElement);
    window.addEventListener('touchstart', this.touchstart);
    window.addEventListener('touchmove', this.touchmove);
    window.addEventListener('mousewheel', this.handleMousewheelThrottled);
  };

  removeScrollListener = () => {
    // window.removeEventListener('DOMMouseScroll', this.onScroll);
    window.removeEventListener('scroll ', this.handleScrollThrottled);
    // window.removeEventListener('touchmove', this.moveElement);
    window.removeEventListener('touchstart', this.touchstart);
    window.removeEventListener('touchmove', this.touchmove);
    window.removeEventListener('mousewheel', this.handleMousewheelThrottled);
  };

  touchstart = e => {
    this.ts = e.changedTouches[0].clientY;
  };

  touchmove = e => {
    var te = e.changedTouches[0].clientY;

    if (this.ts > te + 5) {
      this.moveElement('down');
    } else if (this.ts < te - 5) {
      this.moveElement('up');
    }
  };

  onPageLoadSetScrollArea = () => {
    var sticker = document.querySelector('#scrollMe');
    let sticketStyle = window.getComputedStyle(sticker);
    let marginVal = GetMarginValue(parseInt(sticketStyle.height));

    sticker.style.marginTop = marginVal + 'px';
  };

  onScroll = () => {
    if (window.scrollY === 0) {
      var sticker = document.querySelector('#scrollMe');
      sticker.style.marginTop = null;
      sticker.dataset.inview = 'false';

      scrollBlocker.enable();
      this.setScrollShadowCss();
    }
  };

  onMousewheel = e => {
    if (!isDesktop) {
      this.removeScrollListener();
      return;
    }

    var delta = null,
      direction = false;
    if (!e) {
      e = window.event;
    }
    if (e.wheelDelta) {
      delta = e.wheelDelta / 60;
    } else if (e.detail) {
      delta = -e.detail / 2;
    }
    if (delta !== null) {
      direction = delta > 0 ? 'up' : 'down';
    }
    this.moveElement(direction);
  };

  moveElement = direction => {
    var sticker = document.querySelector('#scrollMe');

    var bodyEle = document.querySelector('body');
    if (bodyEle.classList.contains('calendar-open')) {
      return;
    }

    if (!isDesktop) {
      this.removeScrollListener();
      return;
    }

    if (!window.getComputedStyle && !sticker) {
      return;
    }

    if (direction === 'down' && sticker.dataset.inview === 'false') {
      scrollBlocker.enable();

      let sticketStyle = window.getComputedStyle(sticker);
      var topMargin = sticketStyle.marginTop.match(/\d+/)[0];

      let offset = 100;

      let marginVal = GetMarginValue(parseInt(sticketStyle.height));

      if (topMargin >= offset) {
        var newMargin = topMargin - offset;

        if (newMargin <= marginVal) {
          newMargin = marginVal;
          sticker.classList.add('already-visible');

          scrollBlocker.disable();

          sticker.dataset.inview = 'true';
          this.setState({ scrollShadow: {} });
        }
        sticker.style.marginTop = newMargin + 'px';
        this.checkScrollEleFullVisible();
      }
    }
  };

  getScrollMeComputeStyle = () => {
    var sticker = document.querySelector('#scrollMe');
    let sticketStyle = window.getComputedStyle(sticker);
    return sticketStyle;
  };

  checkScrollEleFullVisible = () => {
    var sticker = document.querySelector('#scrollMe');
    let sticketStyle = this.getScrollMeComputeStyle();
    let ComponentHeight = this.getComponentHeight();

    if (this.state.wHeight <= ComponentHeight) {
      if (
        parseInt(sticker.style.marginTop, 10) +
          parseInt(this.state.wHeight, 10) <=
        parseInt(sticketStyle.height, 10)
      ) {
        this.setState({ scrollShadow: {} });
      }
    } else {
      if (
        parseInt(sticker.style.marginTop, 10) +
          parseInt(sticketStyle.height, 10) <=
        parseInt(ComponentHeight, 10)
      ) {
        this.setState({ scrollShadow: {} });
      }
    }
  };

  updateSize = () => {
    let wHeight = window.innerHeight;
    let wWidth = window.innerWidth;

    this.setState({ wHeight: wHeight, wWidth: wWidth });

    const { fields } = this.props;
    const FeatureHeroData = get(fields, 'FeatureHeroData', {});
    const SelectedFeatures = get(FeatureHeroData, 'SelectedFeatures', []);

    if (isDesktop && !isTablet) {
      if (wWidth < scrollBreakPoint && wWidth > scrollIpadBreakPoint) {
        this.onPageLoadSetScrollArea();
      } else if (wWidth > scrollBreakPoint) {
        if (!isFirefox && SelectedFeatures.length > 5) {
          this.moveElement();
          this.bindScrollListener();
          scrollBlocker.enable();
          // this.setScrollShadowCss();
        } else {
          this.onPageLoadSetScrollArea();
        }
      }
    } else if (isTablet) {
      this.onPageLoadSetScrollArea();
    }
  };

  isDarkMode = () => {
    const { fields } = this.props;
    const ThemeName = get(
      fields,
      'FeatureHeroData.Theme.fields.ThemeName.value',
      '',
    );
    return ThemeName === 'Dark';
  };

  getComponentHeight = () => {
    let componentEle = document.querySelector('.feature-hero');
    let componentHeight = 0;
    if (componentEle !== null) {
      let componentEleCompute = window.getComputedStyle(componentEle);
      componentHeight = parseInt(componentEleCompute.height, 10);
    }
    return componentHeight;
  };

  setScrollShadowCss = () => {
    let sticker = document.querySelector('#scrollMe');
    let sticketStyle = window.getComputedStyle(sticker);
    const { wWidth } = this.state;

    if (isDesktop && wWidth > scrollBreakPoint && !isTablet && !isFirefox) {
      let scrollShadow = {
        width: sticketStyle.width,
        height: '88px',
        background:
          'linear-gradient(\n180deg\n, rgba(255, 255, 255, 0) 0%, #FFFFFF 100.09%)',
      };

      let componentHeight = this.getComponentHeight();

      let covidBannerEle = document.querySelector('.covid19-banner-wrap');
      let covidBannerEleHeight = 0;
      if (covidBannerEle !== null) {
        let covidBannerEleCompute = window.getComputedStyle(covidBannerEle);
        covidBannerEleHeight = parseInt(covidBannerEleCompute.height, 10);
      }

      if (this.state.wHeight <= componentHeight) {
        sticker.style.marginTop = this.state.wHeight / 2 + 'px';
        scrollShadow['top'] = this.state.wHeight - 88 - covidBannerEleHeight;
      } else {
        scrollShadow['bottom'] = 0;
      }

      scrollShadow['opacity'] = 1;

      const { fields } = this.props;
      const FeatureHeroData = get(fields, 'FeatureHeroData', {});
      const SelectedFeatures = get(FeatureHeroData, 'SelectedFeatures', []);

      this.setState({
        scrollShadow: SelectedFeatures.length > 5 ? scrollShadow : {},

        scrollMeVisibility: 'visible',
      });
    } else {
      this.setState({
        scrollMeVisibility: 'visible',
      });
    }
  };

  getScrollShadowCss = () => {
    const { scrollShadow } = this.state;
    return scrollShadow && Styles.scrollShadow(scrollShadow);
  };

  render() {
    const isDarkMode = this.isDarkMode();
    const { fields } = this.props;
    const { scrollShadow, wWidth, scrollMeVisibility } = this.state;

    const FeatureHeroData = get(fields, 'FeatureHeroData', {});

    // FeatureHeroData.Image.value.src =
    //   'http://regus.dev.local/' + FeatureHeroData.Image.value.src;
    return (
      <Spacer
        customCss={[
          Styles.containerSizesTop,
          Styles.CommonCss,
          // isDarkMode ? Styles.DarkModeCss : Styles.LightModeCss,
        ]}
        containerProps={{
          ref: this.FeatureHerosRef,
          className: 'feature-hero show-blur-nav',
        }}
      >
        <div
          css={[
            Styles.RelativePositionCss,
            isDarkMode
              ? Styles.RelativePositionDarkModeCss
              : Styles.RelativePositionLightModeCss,
          ]}
          className="content-holder"
        >
          <Container
            css={[
              Styles.featureherosec,
              isDarkMode ? Styles.DarkModeCss : Styles.LightModeCss,
            ]}
          >
            <div css={[Styles.imageBlock]}>
              <div className="shadow_tab"></div>
              <Picture
                image={FeatureHeroData.Image}
                imageSizes={mainImageSizes}
                imageClassName="hero_img"
                instantLoad
              />
            </div>

            <div css={[Styles.floatingArea, Styles.titleBlockHolder]}>
              <TitleBlock
                isDarkMode={this.isDarkMode()}
                fields={FeatureHeroData}
              />
            </div>

            <div
              css={[
                Styles.floatingArea,
                Styles.scrollMeHolder(scrollMeVisibility),
                isDarkMode
                  ? Styles.scrollmeDarkModeCss
                  : Styles.scrollmeLightModeCss,
              ]}
            >
              <div
                css={[
                  isDesktop &&
                    wWidth >= scrollBreakPoint &&
                    !isTablet &&
                    Styles.scrollArea,
                  (isTablet ||
                    (isDesktop &&
                      wWidth < scrollBreakPoint &&
                      wWidth > scrollIpadBreakPoint)) &&
                    Styles.scrollAreaIpad,
                  (isMobileOnly ||
                    (isDesktop && wWidth < scrollIpadBreakPoint)) &&
                    Styles.scrollAreaMobile,
                ]}
                id="scrollMe"
                data-inview="false"
              >
                <ScrollerBlock
                  setScrollShadowCss={this.setScrollShadowCss}
                  isDarkMode={this.isDarkMode()}
                  fields={FeatureHeroData}
                />
              </div>
              <div
                css={[this.getScrollShadowCss(scrollShadow)]}
                className="shadow_bg"
              ></div>
            </div>
          </Container>
        </div>
      </Spacer>
    );
  }
}

export default FeatureHeros;
